import { render, staticRenderFns } from "./field-marketing-consent.vue?vue&type=template&id=f9d75a60&"
import script from "./field-marketing-consent.vue?vue&type=script&lang=js&"
export * from "./field-marketing-consent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports